// extracted by css-extract-rspack-plugin
export default {"icon":"product-detail-fragment__Icon_icon__Wj21E"};